import React from 'react';
import { FaInstagram } from 'react-icons/fa';
import { FiYoutube } from 'react-icons/fi';
import { TbBrandTiktok } from 'react-icons/tb';
import './index.css';

function Footer() {
    return (
        <div className='footer'>
            {/* <p className='footer__copyright'>
                &copy; {new Date().getFullYear()}
                &nbsp;WellEd Labs Corp.
                &nbsp;All Rights Reserved
            </p> */}
            {/* <div className='footer__social'>
                <a
                    href='https://www.instagram.com/thesatcrashcourse/'
                    target='_blank'
                    rel='noopener noreferrer'
                >
                    <FaInstagram className='footer__socialIcon' />
                </a>
                <a
                    href='https://www.tiktok.com/@thesatcrashcourse'
                    target='_blank'
                    rel='noopener noreferrer'
                >
                    <TbBrandTiktok className='footer__socialIcon' />
                </a>
                <a
                    href='https://www.youtube.com/@thesatcrashcourse/featured'
                    target='_blank'
                    rel='noopener noreferrer'
                >
                    <FiYoutube className='footer__socialIcon' />
                </a>
            </div> */}
        </div>
    );
}

export default Footer;